import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import When from 'components/When';
import Message from '../Message';
import './CardTitle.scss';

const { block, element } = bem('card-title');

function CardTitle({ className = '', collapsed, children, rightText, rightContent = null, ...rest }) {
  if (rightText || rightContent) {
    return (
      <div className={block(className, { collapsed })} {...rest}>
        <h4>{children}</h4>
        <When predicate={!!rightText}>
          <Message className={element('required-text')} message={rightText} />
        </When>
        <When predicate={!!rightContent}>{rightContent()}</When>
      </div>
    );
  }

  return (
    <h4 className={block(className, { collapsed })} {...rest}>
      {children}
    </h4>
  );
}

CardTitle.propTypes = {
  children: PropTypes.node,
  collapsed: PropTypes.bool,
  className: PropTypes.string,
  rightText: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  rightContent: PropTypes.func,
};

export default CardTitle;
